export class CodeNameBase {
    constructor(
        public code: string,
        public name: string
    ) {
    }

    public clone = (): CodeNameBase => {
        let clone = new CodeNameBase(this.code, this.name);
        return clone;
    }
}

export class CodeName extends CodeNameBase {
    constructor(
        public id: number,
        public selected: boolean,
        code: string,
        name: string
        ) {
        super(code, name)
    }
    public findCode: boolean;
    public findName: boolean;
    public disabled: boolean;

    public clone = (): CodeName => {
        let clone = new CodeName(this.id, this.selected, this.code, this.name);
        clone.findName = this.findName;
        clone.findCode = this.findCode;
        clone.disabled = this.disabled;
        return clone;
    }
}

export class CodeNameSummaryChart {
    constructor(
        public itemId: number,
        public skuCode: string,
        public skuName: string,
        public warehouseCode: string,
        public warehouseName: string
    ) {

    }

    public clone = (): CodeNameSummaryChart => {
        return new CodeNameSummaryChart(this.itemId, this.skuCode, this.skuName, this.warehouseCode, this.warehouseName);
    }
}

export class StocksColumnItem extends CodeName {
    constructor(
        id: number,
        selected: boolean,
        code: string,
        name: string,
        public readonly group: string
    ) {
        super(id, selected, code, name)
        this.table = TableGrid.NoSelected;
    }

    public table: TableGrid;

    public clone = (): StocksColumnItem => {
        let clone = new StocksColumnItem(this.id, this.selected, this.code, this.name, this.group);
        clone.findName = this.findName;
        clone.findCode = this.findCode;
        clone.disabled = this.disabled;
        return clone;
    }
}

export enum TableGrid {
    NoSelected = 0,
    View = 1,
    Parameters = 2
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/code-name.ts